/** Match `answers["id"]` / `answers['id']` inside a Jinja-style runtime template. */
const ANSWERS_REF_RE = /answers\s*\[\s*["']([^"']+)["']\s*\]/g

/** Any `{{ … }}` placeholder (embedded data or answers). */
const TEMPLATE_PLACEHOLDER_RE = /\{\{[\s\S]*?\}\}/

/** Question ids referenced via `answers["…"]` in a runtime wording template. */
export function referencedAnswerIds(template: string): Set<string> {
  const ids = new Set<string>()

  for (const match of template.matchAll(ANSWERS_REF_RE)) {
    if (match[1]) ids.add(match[1])
  }

  return ids
}

/** True when the string still contains unresolved `{{ … }}` placeholders. */
export function hasTemplatePlaceholder(template: string): boolean {
  return TEMPLATE_PLACEHOLDER_RE.test(template)
}

/**
 * Prefer server-rendered `wordings[id]`. If missing, show the runtime template only when
 * it has no placeholders — never show raw `{{ … }}` to the respondent.
 */
export function displayWording(id: string, template: string, wordings: Record<string, string>): string {
  const rendered = wordings[id]

  if (typeof rendered === 'string') return rendered
  if (!hasTemplatePlaceholder(template)) return template

  return ''
}
